import { render, staticRenderFns } from "./el-popover.vue?vue&type=template&id=616961fc"
import script from "./el-popover.vue?vue&type=script&lang=js"
export * from "./el-popover.vue?vue&type=script&lang=js"
import style0 from "./el-popover.vue?vue&type=style&index=0&id=616961fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports